<button class="icon-button" (click)="onClicked()">
  <ng-content></ng-content>
</button>
